import './page.scss'
import React from 'react'
import Header from '../header/header'

type PageProps = {
  children: React.ReactNode
}
const Page: React.FC<PageProps> = (props) => {
  return (
    <div className="page">
      <Header />
      <div className="auto-margin">{props.children}</div>
    </div>
  )
}

export default Page
